import React from "react";
import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";

// topojson de países servido localmente (baixado no prebuild p/ public/data).
const WORLD_TOPO = `${process.env.PUBLIC_URL || ""}/data/world-110m.json`;

// Plota uma bolha por cidade em (lon, lat), com raio proporcional à contagem.
export default function ResultsMap({ cities = [] }) {
  const pts = cities.filter((c) => Number.isFinite(c.lat) && Number.isFinite(c.lon));
  const max = Math.max(1, ...pts.map((c) => c.count || 1));
  return (
    <div className="overflow-hidden rounded-md bg-background">
      <ComposableMap
        projection="geoMercator"
        projectionConfig={{ scale: 70, center: [10, 20] }}
        width={320}
        height={200}
        style={{ width: "100%", height: "auto" }}
      >
        <Geographies geography={WORLD_TOPO}>
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill="hsl(var(--muted))"
                stroke="hsl(var(--border))"
                strokeWidth={0.3}
                style={{ default: { outline: "none" }, hover: { outline: "none" }, pressed: { outline: "none" } }}
              />
            ))
          }
        </Geographies>
        {pts.map((c, i) => {
          const r = 2 + 5 * Math.sqrt((c.count || 1) / max);
          return (
            <Marker key={i} coordinates={[c.lon, c.lat]}>
              <circle r={r} fill="hsl(var(--primary))" fillOpacity={0.65} stroke="hsl(var(--primary))" strokeWidth={0.4} />
            </Marker>
          );
        })}
      </ComposableMap>
    </div>
  );
}
